import { useCallback, useState } from "react";
import { ORDER, SORTING } from "components/payment/PaymentTable/constants";

export interface PaymentTableSortingAction {
  type?: string;
}

export interface PaymentTableSortingHook {
  sorting: string;
  order: string;
  onAction: (action?: PaymentTableSortingAction) => void;
}

export default function usePaymentTableSorting(): PaymentTableSortingHook {
  const [sorting, setSorting] = useState(SORTING.UPDATED_AT);
  const [order, setOrder] = useState(ORDER.NORMAL);

  const onAction = useCallback(
    (action: PaymentTableSortingAction = {}) => {
      const { type } = action;

      if (type === "price-ascending") {
        setSorting(SORTING.PRICE);
        setOrder(ORDER.NORMAL);
        return;
      }

      if (type === "price-descending") {
        setSorting(SORTING.PRICE);
        setOrder(ORDER.INVERSE);
        return;
      }

      if (type === "id-alphabetical") {
        if (sorting !== SORTING.ID) {
          setSorting(SORTING.ID);
          setOrder(ORDER.NORMAL);
          return;
        }
        if (order === ORDER.NORMAL) {
          setOrder(ORDER.INVERSE);
          return;
        }
        setOrder(ORDER.NORMAL);
        return;
      }

      if (type === "loan-ascending") {
        setSorting(SORTING.LOAN);
        setOrder(ORDER.NORMAL);
        return;
      }

      if (type === "loan-descending") {
        setSorting(SORTING.LOAN);
        setOrder(ORDER.INVERSE);
        return;
      }

      if (type === "deposit-ascending") {
        setSorting(SORTING.DEPOSIT);
        setOrder(ORDER.NORMAL);
        return;
      }

      if (type === "deposit-descending") {
        setSorting(SORTING.DEPOSIT);
        setOrder(ORDER.INVERSE);
        return;
      }

      if (type === "job-alphabetical") {
        if (sorting !== SORTING.JOB_TITLE) {
          setSorting(SORTING.JOB_TITLE);
          setOrder(ORDER.NORMAL);
          return;
        }
        if (order === ORDER.NORMAL) {
          setOrder(ORDER.INVERSE);
          return;
        }
        setOrder(ORDER.NORMAL);
        return;
      }

      if (type === "job-id-alphabetical") {
        if (sorting !== SORTING.JOB_ID) {
          setSorting(SORTING.JOB_ID);
          setOrder(ORDER.NORMAL);
          return;
        }
        if (order === ORDER.NORMAL) {
          setOrder(ORDER.INVERSE);
          return;
        }
        setOrder(ORDER.NORMAL);
        return;
      }

      if (type === "name-alphabetical") {
        if (sorting !== SORTING.CUSTOMER) {
          setSorting(SORTING.CUSTOMER);
          setOrder(ORDER.NORMAL);
          return;
        }
        if (order === ORDER.NORMAL) {
          setOrder(ORDER.INVERSE);
          return;
        }
        setOrder(ORDER.NORMAL);
        return;
      }

      if (type === "company-name-alphabetical") {
        if (sorting !== SORTING.COMPANY) {
          setSorting(SORTING.COMPANY);
          setOrder(ORDER.NORMAL);
          return;
        }
        if (order === ORDER.NORMAL) {
          setOrder(ORDER.INVERSE);
          return;
        }
        setOrder(ORDER.NORMAL);
        return;
      }

      if (type === "activity-ascending") {
        setSorting(SORTING.UPDATED_AT);
        setOrder(ORDER.NORMAL);
        return;
      }

      if (type === "activity-descending") {
        setSorting(SORTING.UPDATED_AT);
        setOrder(ORDER.INVERSE);
        return;
      }

      setSorting(SORTING.UPDATED_AT);
      setOrder(ORDER.NORMAL);
    },
    [order, sorting]
  );

  return {
    sorting,
    order,
    onAction,
  };
}
